import React, {useState,useEffect} from 'react';
import Sidebar from '../Components/Sidebar'
import Navbar from '../Components/Navbar'
import '../Assets/css/App.css';
import {processCreateApi , productlistApi,productDelete,singleProductApi,updateProductApi} from '../Commons/Urls';
import {Modal} from "antd";
import axios from 'axios';
import Swal from 'sweetalert2';
import '../Assets/css/product_list.css';
import Invoice from '../Assets/images/Invoice2.png'


function ProductList() {

const [screenWidth, setScreenWidth] = useState(window.innerWidth);
const [visible,setVisible ] = useState(false);
const [edit,setEdit ] = useState(false);
const token = sessionStorage.getItem('TOKEN');

const handleClick = () => {
    Swal.fire({
        title: "New Product created",
        // text: "Successfully created the product",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });
  };
  
  const handleDeleted = (product_id) => {
    Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Delete",
        focusConfirm: false
        
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "Deleted!",
            text: "Your product has been deleted.",
            icon: "success"
          });
          Handledelete(product_id);
        }
        
      });
  };


const [ name,setname ] = useState('');
const [ id,setid ] = useState('');

const HandleSubmit = async(e)=>{
    e.preventDefault();

   try {
        const res = await axios.post(`${processCreateApi}`,{name},{
          headers: {
            'Content-Type': 'application/json', 
            Authorization: "Bearer " + token
          }
        });
        console.log("res=====",res)
        if (res.data.status){
        //   toast.success(res && res.data.message);
          console.log(res && res.data.message)
          handleClick();
          setname('')
          getalllistproducts();

          
        }else{
        //   toast.error(res.data.message)
        //   console.log(res.data.message)
        }
       
   } catch (error) {
       console.log(error);
    //    toast.error('Something went wrong');
    
   }
   setVisible(false)
}

 const [ listproduct,setlistproduct ] = useState([])
 const getalllistproducts= async ()=>{
 
    try {
        const{data}=await axios.get(`${productlistApi}`,{
          headers: {
            'Content-Type': 'application/json', 
            Authorization: "Bearer " + token
          }
        }) ;
        if(data.status){
            setlistproduct(data.data); // table name
        }
        console.log("data======",data)
       
        
    } catch (error) {
       console.log(error)  
      //  toast.error("Error occured")
  
        
    }
  
  }

  useEffect(() => {

    getalllistproducts();
   

    const handleResize = () => { setScreenWidth(window.innerWidth); };

    window.addEventListener('resize', handleResize);
    return () => {
        window.removeEventListener('resize', handleResize);
    };
   
    
}, []);

const editalert = () => {
   
Swal.fire({

  icon: "success",
  title: "Successfully updated",
  showConfirmButton: false,
  timer: 1500
});
  };


const listsingleproduct= async (product_id)=>{

    setEdit(true);
    try {
        const{data}=await axios.post(`${singleProductApi}`,{product_id},{
          headers: {
            'Content-Type': 'application/json', 
            Authorization: "Bearer " + token
          }
        }) ;
        if(data.status){
            setname(data.data.name)
            setid(data.data.id)
            
        }
       
        
    } catch (error) {
       console.log(error)
    }
  }



function ClearProduct(){
    setname('')
    setVisible(false)
}

function ClearProductEdit(){
  setname('')
  setEdit(false)
}




const Handledelete = async(product_id) =>{
    
    try { 
        const{data}=await axios.post(`${productDelete}`,{product_id},{
          headers: {
            'Content-Type': 'application/json', 
            Authorization: "Bearer " + token
          }
        });

        if(data.status){
       
            console.log(data.status)
            getalllistproducts();
        }else{
            // toast.error(data.message)

        }
    } catch (error) {
        console.log(error)
        // toast.error('error in delection')
        
    }
}

const handleUpdate = async () => {
    // e.preventDefault();
    try {

      const {data} = axios.post(`${updateProductApi}`,{product_id:id,name},{
        headers: {
          'Content-Type': 'application/json', 
          Authorization: "Bearer " + token
        }
      });
      getalllistproducts();
      setEdit(false)
    //   console.log("datasss____",data)
      if (data?.success) {
        // toast.error(data?.message);
        console.log("sucesss")
      } else {

        console.log("error")
      }

      getalllistproducts();
      setVisible(false)

    } catch (error) {
      console.log(error);
 
    }
    getalllistproducts();
    setname('')
    setid('')
    editalert()

  };



  return (
    <>
   
   <div>
   <Navbar activePage="product_list"/>
   <div className='bg-[#f8f8f9] px-[48px] min-h-[100vh] pb-[80px]   pt-[86px]
                  max-sm:px-[20px]  ' style={{fontFamily:'Montserrat, sans-serif'}} >

      <div className='w-auto h-auto '>
        <div className=' flex justify-between'>
         <h1 className='font-[600] text-[24px] leading-[29.26px] text-[#343434]
                         max-sm:text-[20px]'>Product List</h1>

      {screenWidth < 756 ?
      <button className="bg-[#F4CF7B] hover:bg-[#e7ca88] text-[#7A4310] font-[600]   px-2.5 py-1.5 text-[12px] border border-[#F4CF7B] rounded  " onClick={(()=>setVisible(true))}>
      
       <span className="material-symbols-outlined text-[18px] pt-1 ">add</span>
       </button>
      :
         <button className="flex items-center bg-[#F4CF7B] hover:bg-[#dbba6c] h-[48px] w-[201px] text-[#7A4310] font-[600] text-[14px] py-2 px-4  rounded " onClick={(()=>setVisible(true))}>
            <span className="material-symbols-outlined mr-1  text-[20px]">add</span>Add New Product</button>
      }
        </div>

        {listproduct && listproduct.length===0?
        
        <div className=' h-[40vh] w-[100%] mt-[54px]'>
          <div className='flex justify-center place-items-end '>
            <div className=' flex justify-center items-center flex-col'>
              
            <img src={Invoice} alt=''/>
            <h1 className='font-[600] text-[20px] leading-[24px] text-[#1C1C1C]'>No Products Available</h1>
            
          </div>
          </div>

        </div>

        :
        
        <div className='mt-[24px]  '> 
        <div className='flex justify-center'>
        {/* {loader? <div><div role="status"className=' '>
           <svg aria-hidden="true" className="w-8 h-8  text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
             <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
             <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
           </svg>
           <span className="sr-only">Loading...</span>
           </div></div>
          :""} */}
        
        </div>
  
        <div className= ' bottom-div-with-hidden-scrollbar h-auto   overflow-x-auto ' >
  

        <table className="w-full text-sm text-left rtl:text-right">
            <thead className="bg-[#FFFAEE] text-[#393939] text-[14px] font-[500] h-[67px] leading-[16.94px] max-sm:text-[12px]"style={{whiteSpace:'nowrap'}} >
        <tr>
          <th scope="col" className="px-6 py-3 w-[80%] ">
          Product Name
          </th>
          <th scope="col" className="px-[45px] py-3 w-[20%]">
          Action
          </th>
         
        </tr>
            </thead>

                    <tbody className='h-[70px] font-[500] text-[14px] leading-[19.36px] text-[#464646] max-sm:text-[12px]'  style={{fontFamily:'Montserrat, sans-serif'}}>
                    {listproduct.map( (all) =>(
                            <>
                        <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                    
                            <th scope="row" className="px-6 py-4 font-medium   w-[173px]  ">
                                
                                    <div className='flex  items-center' key={all.id}>{all.name}</div> 
                                  
                            </th>
                       
       
                          
                            <td className="px-[33px] py-4  ">
                                <div className=' w-[70px] flex justify-between max-sm:w-[60px] max-sm:ml-[5px]'>
                                    <span className="material-symbols-outlined font-[300]  cursor-pointer max-sm:text-[22px] "  type="button" onClick={(()=>listsingleproduct(all.id))}  > border_color</span>
                                    <span className="material-symbols-outlined font-[300]  cursor-pointer max-sm:text-[22px] " type="button" onClick={(()=>handleDeleted(all.id))}  > delete</span>
                                </div>
                            </td>
                        </tr>
                            </>
                        ))}
                    </tbody>
            
            
        </table>
    </div>



        </div>
}

      
      
      </div>
      <Modal onCancel = {()=>  ClearProduct()} 
        footer={null} 
        visible={visible}
        width={596}
        
        top={0}>
         <div className='pt-[20px] pb-[0px] py-[24px] 'style={{fontFamily:'Montserrat, sans-serif'}}>
        <div className='w-[auto] '>
            <h1 className='font-[600] text-[20px] leading-[24.38px] text-[#1C1C1C] mb-[24px]'>Add New Product</h1>
            <hr></hr>

            {/* --------form------------ */}
            <div className='w-[auto] '>
            <div >
                    <div className="mb-1 mt-6 ">
                        <label className="block text-[#32324D] text-[12px] font-[400] leading-[16px] mb-2" >
                        Product Name
                        </label>
                        <input className=" bg-[#FAFAFA] border border-[#E3E3E3] rounded w-full h-[40px] py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="username" type="text" placeholder='Eg. Boniheal Tab : 20 Tab'  autoComplete='off' 
                         value={name}
                         onChange={(e)=>setname(e.target.value)}/>             
                        {/* {getNameEnableError ? <p  className="relative self-center text-center text-[medium] not-italic text-[#dc3545]">aaa</p> : <div></div>} */}
                        </div>
                        
                    
                    </div>
                    <div className='mt-[30px]  h-[49px] flex items-center relative '>
                            
                            <div className='absolute right-0 w-[203] h-[49px]  '>
                            <button className="bg-[#ffff] absolute right-[105px] hover:bg-[#fcfaf7] text-black font-[400] text-[14px]  px-4 border border-[#EBEBEB] rounded mr-3 mt-0 h-[49px] w-[98px]  " onClick={ClearProduct}>Cancel</button>
                            <button className='bg-[#F4CF7B] absolute right-0 hover:bg-[#e7ca88] text-[#7A4310] font-[600] text-[14px] border border-[#F4CF7B] w-[105px] h-[48px] rounded m-0 ' type={'submit'} onClick={HandleSubmit} >

                                        {/* {isLoading ?  <div role="status"className='ml-[35px]  '>
                                        <svg aria-hidden="true" className="w-8 h-8  text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                                        </svg>
                                        <span className="sr-only">Loading...</span>
                                    </div>

                                        :'Save'} */}
                                        Save
                            </button>


                            </div>
                        </div>
            </div>

            {/* --------form  end------------ */}
        </div>
    </div>
    </Modal>



    {/*-----table edit-----modal  */}
    <Modal onCancel = {()=>  {ClearProductEdit()}} 
       footer={null} 
        visible={edit}
        width={596}
        
        top={0}>
         <div className='pt-[20px] pb-[0px] py-[24px] 'style={{fontFamily:'Montserrat, sans-serif'}}>
        <div className='w-[auto] '>
            <h1 className='font-[600] text-[20px] leading-[24.38px] text-[#1C1C1C] mb-[24px]'>Edit Product</h1>
            <hr></hr>

            {/* --------form------------ */}
            <div className='w-[auto] '>
            <div >
                    <div className="mb-1 mt-6 ">
                        <label className="block text-[#32324D] text-[12px] font-[400] leading-[16px] mb-2" >
                        Product Name
                        </label>
                        <input className=" bg-[#FAFAFA] border border-[#E3E3E3] rounded w-full h-[40px] py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="username" type="text" placeholder='Eg. Boniheal Tab : 20 Tab'  autoComplete='off' 
                        value={name}
                        onChange={(e)=>setname(e.target.value)}/> 
                        {/* {getNameEnableError ? <p  className="relative self-center text-center text-[medium] not-italic text-[#dc3545]">aaa</p> : <div></div>} */}
                        </div>
                        
                    
                    </div>
                    <div className='mt-[30px]  h-[49px] flex items-center relative '>
                            
                            <div className='absolute right-0 w-[203] h-[49px]  '>
                            <button className="bg-[#ffff] absolute right-[135px] hover:bg-[#fcfaf7] text-black font-[400] text-[14px]  px-4 border border-[#EBEBEB] rounded mr-3 mt-0 h-[49px] w-[98px]" onClick={(()=>ClearProductEdit())} >Cancel</button>
                            <button className='bg-[#F4CF7B] absolute right-0 hover:bg-[#e7ca88] text-[#7A4310] font-[600] text-[14px] border border-[#F4CF7B] w-[135px] h-[48px] rounded m-0 ' type={'submit'} onClick={handleUpdate}>

                                        {/* {isLoading ?  <div role="status"className='ml-[35px]  '>
                                        <svg aria-hidden="true" className="w-8 h-8  text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                                        </svg>
                                        <span className="sr-only">Loading...</span>
                                    </div>

                                        :'Save'} */}
                                        Save Change
                            </button>


                            </div>
                        </div>
            </div>

            {/* --------form  end------------ */}
        </div>
    </div>
    </Modal>

    {/* User Delete Model */}
    {/* <Modal onCancel = {()=> setDelete(false)}  footer={null}  visible={getDelete} width={460} top={0}>
        <div className='pt-[20px] py-[24px]'style={{fontFamily:'Montserrat, sans-serif'}}>
            <div className='w-[auto] '>
                <h1 className='font-[600] text-[20px] leading-[24.38px] text-[#1C1C1C] mb-[24px]'>Delete User</h1>
                <hr></hr>
                <div className='w-[auto] '>
                <h3 className='font-[300] text-[18px] leading-[24.38px] text-[#1C1C1C] mb-[24px]'>Are you sure want to delete {getSelectUserName} user</h3>
                    <div className='mt-[40px]  h-[49px] flex items-center relative'>
                        <div className='absolute right-0 w-[203] h-[49px]   '>
                            <button className="bg-[#ffff] absolute right-[105px] hover:bg-[#fcfaf7] text-black font-[400] text-[14px]  px-4 border border-[#EBEBEB] rounded mr-3 mt-0 h-[49px] w-[98px] "onClick={() => setDelete(false)}>No</button>
                            <button className="bg-[#F4CF7B] absolute right-0 hover:bg-[#e7ca88] text-[#7A4310] font-[600] text-[14px] border border-[#F4CF7B] w-[105px] h-[48px] rounded m-0" onClick={() => deleteUsers()}>Yes</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Modal> */}

    {/* <ErrorModel
          setVisible={setErrorModelVisible}
          getVisible={getErrorModelVisible}
          message={getErrorModelMessage}/> */}
   </div>
    </div>
   </>
  )
}

export default ProductList